import { createSlice } from "@reduxjs/toolkit";

// Reducer
const initialState = {
  isModalOpen: false,
  dismissModalFunc: ()=>{}, // Store a function to dismiss the modal
};

const openedRootModalSlice = createSlice({
  name: 'openedRootModal',
  initialState,
  reducers: {
    
    openModal: (state, action) => {
      state.isModalOpen = true;
      state.dismissModalFunc = action.payload.dismissFunc;
    },

    closeModal: (state) => {
      state.isModalOpen = false;

      if (state.dismissModalFunc) {
        state.dismissModalFunc();
        state.dismissModalFunc = ()=>{}
      }
    },
    // Optionally, a reducer to directly set the dismiss function
    setDismissFunc: (state, action) => {
      state.dismissModalFunc = action.payload;
    },
  },
});

// Actions
export const { openModal, closeModal, setDismissFunc } = openedRootModalSlice.actions;

export default openedRootModalSlice.reducer;